import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { BackendPagination } from "../models/pagination.model";
import { TablePagination } from "../models/components/table/table-pagination.model";

export const useEngagementHistory = (pagination: TablePagination) => {
	const queryClient = useQueryClient();
	const queryKey = ["engagement-history", { pagination }];
	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const backendPagination = new BackendPagination(pagination);
			return await EndpointsService.dataRetriever.getEngagements({
				config: { params: backendPagination },
			});
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
